import { render, staticRenderFns } from "./AlertsPanel.vue?vue&type=template&id=d40a8706&"
import script from "./AlertsPanel.vue?vue&type=script&lang=js&"
export * from "./AlertsPanel.vue?vue&type=script&lang=js&"
import style0 from "./AlertsPanel.vue?vue&type=style&index=0&id=d40a8706&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports